/**
 * Completely clears all browser storage and cookies
 */
export const clearAllStorage = (): void => {
  // Clear all cookies
  if (typeof document !== 'undefined') {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name] = cookie.trim().split('=');
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }

    // Clear all localStorage
    try {
      localStorage.clear();
    } catch (e) {
      console.warn('Could not clear localStorage', e);
    }

    // Clear all sessionStorage
    try {
      sessionStorage.clear();
    } catch (e) {
      console.warn('Could not clear sessionStorage', e);
    }
  }
};

/**
 * Completely clears all auth-related data
 */
export const clearAuthData = (): void => {
  if (typeof document !== 'undefined') {
    // Clear all auth-related cookies
    const authCookies = [
      'token',
      'access_token',
      'refresh_token',
      'session',
      'sessionid',
      'connect.sid',
      'remember_token'
    ];

    authCookies.forEach(cookie => {
      document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
      document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
      document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    // Clear all auth-related storage
    const authStorageKeys = [
      'token',
      'access_token',
      'refresh_token',
      'user',
      'auth',
      'session',
      'sessionid'
    ];

    authStorageKeys.forEach(key => {
      try {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      } catch (e) {
        console.warn(`Could not remove ${key} from storage`, e);
      }
    });
  }
};
